import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import {
  StudentReadingLevelFilters,
  StudentReadingLevelResponse,
} from "@/reports/types";

export const studentReadingLevelQueries = {
  all: () => [ApiCatalog.studentReadingLevel.key] as const,
  filter: (queryParams: StudentReadingLevelFilters, enabled = true) =>
    queryOptions({
      queryKey: [...studentReadingLevelQueries.all(), { ...queryParams }],
      queryFn: () =>
        api().get<StudentReadingLevelResponse>(
          ApiCatalog.studentReadingLevel.endpoint,
          {
            queryParams: {
              ...queryParams,
              entity_type: "student",
            },
          },
        ),
      enabled,
    }),
};
